const mediaQuery = window.matchMedia("(max-width: 767.98px)");
function footerLinksCollapseable(e) {
  if (e.matches) {
    console.log("Media Query Matched!");
    $(".footer-item__title").click(function () {
      $(this).next().slideToggle("fast").parent().toggleClass("active");
    });
  }
}
mediaQuery.addListener(footerLinksCollapseable);
footerLinksCollapseable(mediaQuery);


(function() {
      // Get current time in Denmark (CET/CEST)
      var now = new Date();
      var denmarkTime = new Intl.DateTimeFormat("en-US", { 
          timeZone: "Europe/Copenhagen", 
          hour: "2-digit", 
          hour12: false, 
          weekday: "short" 
      }).formatToParts(now);

      // console.log(denmarkTime);

      var hours = parseInt(denmarkTime.find(part => part.type === "hour").value, 10); // Denmark's hour (0-23)
      var dayName = denmarkTime.find(part => part.type === "weekday").value; // Day name (e.g., "Mon", "Sat")

      var isWeekend = (dayName === "Sat" || dayName === "Sun"); // True if Saturday or Sunday
      var isWorkHours = (hours >= 9 && hours < 17); // 9:00 AM - 5:00 PM Denmark time (Weekdays only)

      if (!isWeekend && isWorkHours) {
          //Load Zendesk Widget (Only on weekdays from 9:00 AM - 5:00 PM in Denmark time)
          var zendeskScript = document.createElement("script");
          zendeskScript.id = "ze-snippet";
          zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=41c8bec2-103d-40c2-bb9d-ebfa46be13f0";
          document.head.appendChild(zendeskScript);
      } else {
          //Load UserLink Widget (Full day on weekends OR outside work hours on weekdays in Denmark time)
          // var userlinkScript = document.createElement("script");
          // userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
          // userlinkScript.charset = "utf-8";
          // userlinkScript.id = "bai-scr-emb";
          // userlinkScript.setAttribute("data-cid", "67d3011cbc5fdc32540061a6");
          // userlinkScript.setAttribute("async", "");
          // userlinkScript.setAttribute("domain", "musclepain.se");
          // document.head.appendChild(userlinkScript);
      }
          // var zendeskScript = document.createElement("script");
          // zendeskScript.id = "ze-snippet";
          // zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=41c8bec2-103d-40c2-bb9d-ebfa46be13f0";
          // document.head.appendChild(zendeskScript);
  })();


 jQuery(document).ready(function() {
   if(jQuery('.logos-box-slider-new').length > 0){
      jQuery('.logos-box-slider-new').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4500,
        arrows: false,
        swipe: false,
        slidesToShow: 4,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        rtl: true,
        infinite: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });  
   }
});